import { UpsDataProps } from "../domain/types";

const Ups2Data: UpsDataProps[] = [
  {
    title: 'Group - A1',
    cardItems: [
      {
        id: 1,
        title: 'UPS - 1',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
      {
        id: 2,
        title: 'UPS - 2',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
    ],
  },
  {
    title: 'Group - A2',
    cardItems: [
      {
        id: 3,
        title: 'UPS - 4',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
      {
        id: 4,
        title: 'UPS - 5',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'warning'
      },
    ],
  },
  {
    title: 'Group - B1',
    cardItems: [
      {
        id: 5,
        title: 'UPS - 7',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
      {
        id: 6,
        title: 'UPS - 8',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'danger'
      },
    ],
  },
  {
    title: 'Group - B2',
    cardItems: [
      {
        id: 7,
        title: 'UPS - 10',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
      {
        id: 8,
        title: 'UPS - 11',
        desc: 'Modular, Eaton 93PM 200kVA',
        tag: {
          name: 'Power Consumption',
          value: '167 kW',
          percentage: '67%'
        },
        type: 'normal'
      },
    ],
  },
];

export default Ups2Data;